import type { ComponentType } from 'react';
import { createContext } from 'react';

import type { MiniEventTracker } from '@shared/types/frontend/mini-event-tracker';

import displayName from '@shared/utils-frontend/display-name';

interface ContextProps {
  miniEventTracker: MiniEventTracker;
}

const MiniEventTrackerContext = createContext<MiniEventTracker>(
  // @ts-expect-error missing properties
  {},
);

const withMiniEventTracker = <P extends ContextProps>(
  Component: ComponentType<P>,
) => {
  const component = (props: Omit<P, 'miniEventTracker'>) => (
    <MiniEventTrackerContext.Consumer>
      {(miniEventTracker: MiniEventTracker) => (
        <Component
          // @ts-expect-error we expect that miniEventTracker can be overwritten in the unit tests
          miniEventTracker={miniEventTracker}
          {...(props as P)}
        />
      )}
    </MiniEventTrackerContext.Consumer>
  );

  component.displayName = displayName(Component);

  return component;
};

export default MiniEventTrackerContext;
export { withMiniEventTracker };
